(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbFormPanel', lbFormPanelDirective);

    function lbFormPanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/form",
            controller:lbFormPanelDirectiveCtrl
        };
    }

    function lbFormPanelDirectiveCtrl($scope, lodash) {
        this.$onInit = function() {
            lodash.set($scope.content,'validation',{});
        }
    }
})();